import { render, staticRenderFns } from "./BlankPage.vue?vue&type=template&id=36662f34&scoped=true"
var script = {}
import style0 from "./BlankPage.vue?vue&type=style&index=0&id=36662f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36662f34",
  null
  
)

export default component.exports